export default __webpack_public_path__ + "static/media/8k_earth_specular_map.7b4efa59.jpg";